module.exports = __webpack_public_path__ + "static/media/ABCDeptMapFile.0b780291.xlsx";